import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { CM_TOOLTIPS } from "./utils/tooltipsContent";

const CatalogCellEditDialog = ({
  open,
  table,
  column,
  currentValue,
  draftValue,
  saving = false,
  onClose,
  onChange,
  onSave,
}) => {
  const currentLabel = currentValue != null && String(currentValue) !== ""
    ? String(currentValue)
    : "(vuoto)";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{ className: "cm-dialog cm-cell-edit-dialog" }}
    >
      <DialogTitle className="cm-dialog-title">
        Modifica cella — {table}.{column}
      </DialogTitle>
      <DialogContent className="cm-dialog-body">
        <div className="cm-cell-edit-panel">
          <section className="cm-cell-edit-block cm-cell-edit-current">
            <span className="cm-field-label">Valore attuale</span>
            <div className="cm-cell-edit-current-value">{currentLabel}</div>
          </section>
          <section className="cm-cell-edit-block cm-cell-edit-new">
            <label className="cm-field-label" htmlFor="cm-cell-edit-value">
              Nuovo valore
            </label>
            <textarea
              id="cm-cell-edit-value"
              className="cm-input cm-input-area"
              rows={5}
              value={draftValue}
              onChange={(event) => onChange(event.target.value)}
              disabled={saving}
              autoFocus
            />
          </section>
        </div>
      </DialogContent>
      <DialogActions className="cm-dialog-actions">
        <Button onClick={onClose} disabled={saving} title={CM_TOOLTIPS.annullaModifica}>
          Annulla
        </Button>
        <Button variant="contained" onClick={onSave} disabled={saving} title={CM_TOOLTIPS.salvaCella}>
          {saving ? "Salvataggio..." : "Salva"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

CatalogCellEditDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  table: PropTypes.string,
  column: PropTypes.string,
  currentValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  draftValue: PropTypes.string.isRequired,
  saving: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};


export default CatalogCellEditDialog;
